// Mật độ bảng (tokens.md §4): Thoáng là mặc định, Gọn thu đệm ô. Nhớ theo máy này, không theo hồ sơ (cùng lý do với giao diện sáng/tối).
export type Density = 'comfortable' | 'compact';
export const DENSITY_KEY = 'xma.density';

export function readDensity(): Density {
  try { return localStorage.getItem(DENSITY_KEY) === 'compact' ? 'compact' : 'comfortable'; } catch { return 'comfortable'; }
}

/** Ghi lên <html data-density> để CSS toàn app đọc; thoáng thì bỏ thuộc tính. */
export function applyDensity(d: Density): void {
  if (d === 'compact') document.documentElement.dataset.density = 'compact';
  else delete document.documentElement.dataset.density;
}

export function writeDensity(d: Density): void {
  try { localStorage.setItem(DENSITY_KEY, d); } catch { /* chỉ là tuỳ chọn hiển thị */ }
  applyDensity(d);
}
